import React, { useEffect, useRef } from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { useCameraViewContext } from '../context';

export const useImageListScroll = (
  ref: React.RefObject<HTMLDivElement>,
  itemRefs: React.RefObject<HTMLDivElement[]>
) => {
  const { level1SectionId, imageIndex } = useCameraViewContext();
  const { fields } = useFieldArray(`${level1SectionId}.images`);

  const firstRenderRef = useRef<boolean>(true);

  useEffect(() => {
    if (imageIndex === fields.length && ref.current) {
      setTimeout(() => {
        if (!ref.current) return;
        ref.current.scrollTo({
          left: ref.current.scrollWidth,
          behavior: (firstRenderRef.current === true ? 'instant' : 'smooth') as any
        });
        firstRenderRef.current = false;
      }, 200);
      return;
    }

    if (!ref.current || !itemRefs.current![imageIndex]) return;

    const list = ref.current;
    const item = itemRefs.current![imageIndex];

    const listWidth = list.clientWidth;
    const itemWidth = item.clientWidth;

    const itemLeft = item.offsetLeft;

    const targetScroll = itemLeft - (listWidth / 2 - itemWidth / 2);

    const maxScroll = list.scrollWidth - listWidth;
    const clamped = Math.max(0, Math.min(targetScroll, maxScroll));

    list.scrollTo({
      left: clamped,
      behavior: (firstRenderRef.current === true ? 'instant' : 'smooth') as any
    });
    firstRenderRef.current = false;
  }, [imageIndex, fields.length]);

  return { ref, itemRefs };
};
